import { useAssignableTeamsAndUsers } from "@coworker/apprestructured/src/task-management/components/TaskCreatorAndEditorSheet/creator-fragments/AssignToCreatorFragment/useAssignableTeamsAndUsers";
import { useMemo, useState } from "react";
import { useModal } from "./useModal";

export const useAssignToModal = (teamId: string) => {
  const { shown, open, close } = useModal(false);

  const [searchQuery, setSearchQuery] = useState("");

  const handleClose = () => {
    close();
    setSearchQuery("");
  };

  const { assignableTeams, activeUsers, isActiveUsersLoading, isTeamsLoading } =
    useAssignableTeamsAndUsers({ enabled: shown });

  const assignableTeamsExcludingCurrentTeam = useMemo(
    () => assignableTeams.filter((team) => team.id !== teamId),
    [assignableTeams, teamId]
  );

  return {
    shown,
    open,
    close: handleClose,

    assignableTeams: assignableTeamsExcludingCurrentTeam,
    activeUsers,
    isActiveUsersLoading,
    isTeamsLoading,

    searchQuery,
    setSearchQuery,
  };
};
